import { Box, Checkbox, Slider, styled } from "@mui/material";
import { AppContext } from "contexts/AppContext";
import { useState, useEffect, useContext } from "react";
import FilterButton from "./FilterButton";
import ContentExtraSmall from "components/elements/ContentExtraSmall";
import ContentSmall from "components/elements/ContentSmall";
import ContentNormal from "components/elements/ContentNormal";

const PriceSlider = styled(Slider)(({ theme }) => ({
  color: 'black',
  height: '1px',
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&::before': {
      boxShadow: 'none',
    },
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(0, 0, 0, 0.05)',
    },
  },
  '& .MuiSlider-track, .MuiSlider-rail': {
    color: '#222',
    height: '1px',
    border: 'none',
  },
}));

export function PriceFilter(props) {
  const { styleGuide, userData } = useContext(AppContext)
  const {draftValue, setDraftValue, withinMyPointsChecked, setWithinMyPointsChecked, maxValue} = props

  function withinMyPointsClicked() {
    if(withinMyPointsChecked){
      setDraftValue([0, maxValue])
    } else {
      setDraftValue([0, userData?.walletAmountPoints])
    }
    setWithinMyPointsChecked(!withinMyPointsChecked)
  }

  function onPriceRangeUpdate(val){
    setWithinMyPointsChecked(false)
    setDraftValue(val)
  }

  return (
    <Box style={{ maxHeight: 280, overflowY: "auto" }}>
      <Box display={'flex'} justifyContent={'space-between'} gap={2}>
        <Box flex={1} display={'flex'} flexDirection={'column'} backgroundColor={styleGuide.color3} paddingX={2} paddingY={0.5} borderRadius={'14px'}>
          <ContentExtraSmall
            translationKey={'_FILTER_MIN_POINTS_'}
            fallbackText={'Min. point'}
          />
          <ContentSmall>
            <input
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0)',
                border: 'none',
                outline: 'none',
                width: 70
              }}
              value={draftValue[0].toLocaleString('da-DK')}
              onChange={(e) => setDraftValue(prev => [e.target.value, prev[1]])}
            />
          </ContentSmall>
        </Box>
        <Box flex={1} display={'flex'} flexDirection={'column'} backgroundColor={styleGuide.color3} paddingX={2} paddingY={0.5} borderRadius={'14px'}>
          <ContentExtraSmall
            translationKey={'_FILTER_MAX_POINTS_'}
            fallbackText={'Max. point'}
          />
          <ContentSmall>
            <input
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0)',
                border: 'none',
                outline: 'none',
                width: 70
              }}
              value={draftValue[1].toLocaleString('da-DK')}
              onChange={(e) => setDraftValue(prev => [prev[0], e.target.value])}
            />
          </ContentSmall>
        </Box>
      </Box>
      <Box paddingX={3} paddingTop={2}>
        <PriceSlider
          getAriaLabel={() => 'Points range'}
          value={draftValue}
          onChange={(_, newVal) => onPriceRangeUpdate(newVal)}
          getAriaValueText={(val) => `${val} pt`}
          max={maxValue}
        />
      </Box>

      <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} paddingTop={1} paddingX={0.5}>
        <ContentSmall
          translationKey="_SHOP_SORT_WITHIN_MY_POINTS_LABEL_"
          fallbackText="Inden for mine point"
        />
        <Checkbox
          onClick={withinMyPointsClicked}
          checked={withinMyPointsChecked}
          style={{color: withinMyPointsChecked ? styleGuide.color16 : ''}}
        />
      </Box>
    </Box>
  )
}

export function PriceFilterButton({
  label = "Filter",
  value = [],
  onApply,
  maxValue,
}) {
  const [draftValue, setDraftValue] = useState(value)
  const [withinMyPointsChecked, setWithinMyPointsChecked] = useState(false)

  function handleApply() {
    onApply([Number(draftValue[0]), Number(draftValue[1])])
  }

  function handleReset() {
    const defaultValue = [0, maxValue]
    setDraftValue(defaultValue)
    onApply(defaultValue)
  }

  useEffect(() => {
    setDraftValue(value);
  }, [value]);

  useEffect(() => {
    setDraftValue(prev => {
      if(prev[0] > maxValue){
        return [maxValue, maxValue]
      } else if(prev[1] > maxValue){
        return [0, maxValue]
      }
      return prev
    });
  }, [maxValue]);

  return (
    <FilterButton label={label} onApply={handleApply} onReset={handleReset}>
      <PriceFilter
        maxValue={maxValue}
        draftValue={draftValue}
        setDraftValue={setDraftValue}
        withinMyPointsChecked={withinMyPointsChecked}
        setWithinMyPointsChecked={setWithinMyPointsChecked}
      />
    </FilterButton>
  )
}
